var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"size":"sm","variant":"light","block":""},on:{"click":_vm.trigger}},[_vm._v(" "+_vm._s(_vm.locale === 'zh' ? '中' : 'EN')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }